import { render } from "./ButtonDefault.vue?vue&type=template&id=5ea269ea&scoped=true"
import script from "./ButtonDefault.vue?vue&type=script&lang=js"
export * from "./ButtonDefault.vue?vue&type=script&lang=js"

import "./ButtonDefault.vue?vue&type=style&index=0&id=5ea269ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ea269ea"]])

export default __exports__